import { UserModel, UserData } from 'models/UserModel';
import { ApiBase } from 'utils/api';


export default class UserApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    all = (company_id?: number) => this.base.axios
        .get('/api/users', {params: {company_id}})
        .then(res => res.data);

    create = (data: UserData, companyId: number) => this.base.axios
        .post('/api/users', {...data, companyId});

    sendVerification = (id: string) => this.base.axios
        .post(`/api/users/${id}/send-verification`);

    inviteParty = (id: number, email?: string) => this.base.axios
        .post(`/api/users/invite-party/${id}`, {email});

    update = (data: UserModel) => this.base.axios
        .put(`/api/users/${data.id}`, data)
        .then(res => res.data);

    setRole = (id: string, data: any) => this.base.axios
        .patch(`/api/users/${id}/roles`, data);

    setYards = (id: string, yards: number[]) => this.base.axios
        .post(`/api/users/${id}/yards`, {yards})
        .then(res => res.data);

    setVessels = (id: string, vessels: number[]) => this.base.axios
        .post(`/api/users/${id}/vessels`, {vessels})
        .then(res => res.data);

    delete = (id: string) => this.base.axios
        .delete(`/api/users/${id}`);
}
